export const minimumLength = (
  value: string,
  minimumLength = 3,
  message = `Min ${minimumLength} characters`,
): boolean | string => {
  return (value && value.length >= minimumLength) || message;
};
